import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastmessageService } from 'src/app/toastmessage.service';
import { GrievanceDashboardService } from '../grievance-dashboard.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { Chart } from 'angular-highcharts';
import * as Highcharts from 'highcharts';
import SolidGauge from 'highcharts/modules/solid-gauge';
import More from 'highcharts/highcharts-more';
import { HttpResponse } from '@angular/common/http';
import { Editor, Toolbar } from 'ngx-editor';

More(Highcharts);
SolidGauge(Highcharts);
@Component({
  selector: 'app-ticket-details',
  templateUrl: './ticket-details.component.html',
  styleUrls: ['./ticket-details.component.scss']
})
export class TicketDetailsComponent implements OnInit, OnDestroy {
  // TEXT EDITOR //
  editor: Editor;
  toolbar: Toolbar = [
    ['bold', 'italic'],
    ['underline', 'strike'],
    ['code', 'blockquote'],
    ['ordered_list', 'bullet_list'],
    [{ heading: ['h1', 'h2', 'h3', 'h4', 'h5', 'h6'] }],
    ['link', 'image'],
    ['text_color', 'background_color'],
    ['align_left', 'align_center', 'align_right', 'align_justify'],
  ];
  // END TEXT EDITOR //
  documentStatus = false;
  searchCriteria: any = '';
  filteredSearchDetails: any;
  showDropdown: boolean = false;

  chart: Chart;
  accpetTextremarks: string = '';
  assignTextremarks: string = '';
  escalatedTextremarks: string = '';
  noteTextremarks: string = '';

  selectedFile: File | null = null;
  fileError: string = '';

  showAccepted = false;
  currentActive: string = 'Accept';

  // disabledButton: any;

  disableAccept: boolean = false;
  disableAssign: boolean = false;
  disableEscalate: boolean = false;
  disableNote: boolean = false;


  ticketStatus = 'Open';

  maxChars = 2000;

  // COLLEGE & SCHOOL//
  showHead = false;
  assignshowHead = false;
  escalatedshowHead = false;
  noteshowHead = false;
  //End COLLEGE & SCHOOL//

  onShowMainAccept = true;
  onEscalate = false;
  onNoted = false;


  onAssignShowMain = false;


  // ticket log//
  onacceptticket = true;
  onAssignticket = false;
  onEscalatedticket = false;
  onNoteticket = false;
  // ticket log//



  // BUTTON LIST //
  ACCEPT = false;
  ASSIGN = false;
  ESCALATE = false;
  NOTE = false;
  //END BUTTON LIST //

  //main ticket log //
  ACCEPTED = false;
  ASSIGNED = false;
  ESCALATED = false;
  NOTED = false;
  //main ticket log //
  onaccepttck = false;
  uniqueRef: any;
  grievanceStatusDetails: any;
  grievanceDtls: any;

  trackId: any;
  grievanceId: any;
  trackStatus: any;
  assignTo: any;
  grievanceTrackId: any;
  date: any;
  studentName: any;
  admNO: any;
  uploadStatus: any;
  downloadPdf = false;
  isLoading = false;
  details: any;
  parentDetails: any
  grievanceSaveDetails: any;
  grievanceTrackStatus: any;
  searchDetails: any;
  referred: any;
  numberofDays: any;
  uploadDocumentStatus: boolean;
  onAccepted: boolean = false;
  campusId: any;
  grievianceFileName: any;
  extension: string;

  constructor(private router: Router, private toast: ToastmessageService, private Service: GrievanceDashboardService, private route: ActivatedRoute, private spinner: NgxSpinnerService,) {
    this.Service.data$.subscribe(data => {
      console.log('this.parentDetails', this.parentDetails);

      this.parentDetails = data;
      this.campusId = data.CampusId;
      this.studentName = data.studentName;
      this.admNO = data.admNO;
      this.grievanceTrackId = data.grievanceTrackId;
      this.grievanceId = data.grievanceId;
      this.date = data.date;
      this.downloadPdf = data.uploadStatus;
      this.uniqueRef = data.uniqueRef;
      this.grievanceTrackStatus = data.status;
      this.grievianceFileName = data.grievianceFileName;

      const fromDate = new Date(this.parentDetails.date);
      const currentDate = new Date();

      // Calculate the difference in milliseconds
      const diffInMs = currentDate.getTime() - fromDate.getTime();

      // Convert milliseconds to full days
      const diffInDays = Math.floor(diffInMs / (1000 * 60 * 60 * 24));

      // console.log(`Number of days: ${diffInDays}`);
      this.numberofDays = diffInDays



      this.grievanceDtls = data;
      // console.log('Received:', this.grievanceDtls);
    });
  }

  ngOnInit(): void {
    this.editor = new Editor();
    this.radialBar();
    const saveTab = localStorage.getItem('currentTab');
    if (saveTab) {
      this.currentActive = saveTab;

      if (saveTab === 'Accept') {
        this.onAccept()
      }
      else if (saveTab === 'Assign') {
        this.onAssign()
      }
      else if (saveTab === 'Escalate') {
        this.onEscalated()
      }
      else if (saveTab === 'Note') {
        this.onNote()
      }
    }
    if (this.uniqueRef) {
      this.grievanceStatus();
      console.log(this.uniqueRef);
    }

  }

  grievanceStatus() {
    this.spinner.show();
    this.Service.getGrievanceStatus(this.uniqueRef).subscribe(
      {
        next: (res: any) => {
          if (!res) {
            this.spinner.hide();
            return;
          }
          this.trackId = res.latestDetails.trackId;
          // console.log('this.trackId ',this.trackId );

          this.assignTo = res.latestDetails.assignTo;
          this.grievanceStatusDetails = res;
          this.onAcceptOpen();
          this.getStatusColor();
          // console.log('grievanceStatusDetails', this.grievanceStatusDetails);
          this.spinner.hide();
        },
        error: (err: any) => {
          this.spinner.hide();
        }
      }
    )
  }

  getStudentDownload(admNo: any, greivanceId: any) {
    this.isLoading = true;
    this.spinner.show();
    const extension = '.pdf';
    const docType = '_parent';

    this.Service.getstudentDownlod(this.admNO, this.grievianceFileName).subscribe({
      next: (response: HttpResponse<Blob>) => {
        const contentType = response.headers.get('Content-Type') || 'application/octet-stream';
        const blob = new Blob([response.body!], { type: contentType });

        if (contentType === 'image/jpeg') {
          this.extension = 'jpg';
        } else if (contentType === 'image/png') {
          this.extension = 'png';
        } else if (contentType === 'application/pdf') {
          this.extension = 'pdf';
        }

        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = `grievance-${this.grievanceId}.${this.extension}`;
        a.click();
        window.URL.revokeObjectURL(url);
        this.downloadPdf = true;
        this.isLoading = false;
        this.spinner.hide();
      },
      error: (err: any) => {
        this.downloadPdf = false;
        this.isLoading = false;
        this.spinner.hide();

      }
    });
  }

  mainScreen() {
    // this.Service.setView('grievance');
    this.router.navigate(['/studentGrievanceDashboard']);
    localStorage.removeItem('currentTab');
  }

  showBackgroundColor(color: string) {
    this.currentActive = color;
    localStorage.setItem('currentTab', color);
    // console.log('currentActive', this.currentActive);
  }


  onAcceptOpen() {
    // if (this.grievanceTrackStatus === 'IN PROGRESS' && this.grievanceStatusDetails?.latestDetails.trackType == "ACCEPT") {
    //   this.disableAccept = true;
    //   this.disableAssign = true;
    //   this.disableEscalate = true;
    //   this.disableNote = true;
    //   this.showAccepted = true;
    //   this.onAssignShowMain = false;
    //   this.onEscalate = false;
    //   this.onNoted = false;

    // }
    // else if (this.grievanceTrackStatus === 'OPEN' && this.grievanceStatusDetails?.latestDetails.trackType == "ASSIGN") {
    //   this.showAccepted = false;
    //   this.onAssignShowMain = false;
    //   this.onEscalate = false;
    //   this.onNoted = false;
    //   this.disableAccept = true;
    //   this.disableAssign = true;

    // }
    // else if (this.grievanceTrackStatus === 'OPEN' && this.grievanceStatusDetails?.latestDetails.trackType == "NOTE") {
    //   this.showAccepted = false;
    //   this.onAssignShowMain = false;
    //   this.onEscalate = false;
    //   this.onNoted = false;
    //   this.disableAccept = false;
    //   this.disableAssign = false;
    //   this.disableEscalate = false;
    //   this.disableNote = false;

    // }
    // else if (this.grievanceTrackStatus === 'OPEN' && this.grievanceStatusDetails?.latestDetails.trackType == "ESCALATE") {
    //   this.showAccepted = false;
    //   this.onAssignShowMain = false;
    //   this.onEscalate = false;
    //   this.onNoted = false;
    //   this.disableAccept = true;
    //   this.disableAssign = true;
    //   this.disableEscalate = true;
    // }
    // else if (this.grievanceTrackStatus === 'OPEN' && this.grievanceStatusDetails?.latestDetails.trackStatus == "RESOLVED") {
    //   this.showAccepted = false;
    //   this.onAssignShowMain = false;
    //   this.onEscalate = false;
    //   this.onNoted = false;
    // }
    // else

    const latestStatus = this.grievanceStatusDetails?.latestDetails.trackStatus;
    console.log('latestStatus', latestStatus);
    const status = this.grievanceTrackStatus;
    console.log('latestStatus', status);

    this.showAccepted = false;
    this.onAssignShowMain = false;
    this.onEscalate = false;
    this.onNoted = false;

    this.disableAccept = true;
    this.disableAssign = true;
    this.disableEscalate = true;
    this.disableNote = true;

    if (status === 'IN PROGRESS') {
      if (latestStatus === 'RESOLVED') {
        this.showAccepted = false;
      }
      else {
        this.showAccepted = true;
      }
    }

    else if (status === 'OPEN') {
      if (latestStatus === 'IN PROGRESS') {
        this.showAccepted = true;
      } else if (latestStatus === 'RESOLVED') {
      } else {
        this.disableAccept = false;
      }
    }
    else if (status === 'RESOLVED') {
      // All flags stay disabled
    }
    else {
      console.log('NO DATA');
    }

  }

  onAccept() {
    this.onAccepted = true;
    this.getStatusColor();
    const formData = new FormData();
    formData.append("trackId", this.trackId);
    formData.append("grievanceId", this.grievanceId);
    formData.append("trackStatus", 'IN PROGRESS');
    formData.append("assignTo", this.assignTo || '');
    formData.append("description", this.accpetTextremarks);
    formData.append("empBuildingId", '0');
    formData.append("uploadDocumentStatus", this.documentStatus ? 'true' : 'false');
    formData.append("trackType", 'ACCEPT');
    formData.append("admNo", this.admNO);
    if (this.selectedFile) {
      formData.append("file", this.selectedFile);
    }
    this.spinner.show();
    this.Service.postGrievance(formData).subscribe({
      next: (res: any) => {
        if (!res) {
          this.spinner.hide();
          return;
        }
        this.grievanceSaveDetails = res;
        this.trackStatus = 'IN PROGRESS'
        this.getStatusColor();
        // console.log('grievanceSaveDetails', this.grievanceSaveDetails)
        this.spinner.hide();

        this.showAccepted = true;
        this.onAssignShowMain = false;
        this.onEscalate = false;
        this.onNoted = false;

        this.disableAccept = true;
        this.disableAssign = true;
        this.disableEscalate = true;
        this.disableNote = true;
        this.showBackgroundColor('Accept');
        this.grievanceStatus();
      },
      error: (err: any) => {
        this.spinner.hide();
      },
    });
  }

  getStatusColor() {
    switch (this.grievanceStatusDetails?.latestDetails.trackStatus) {
      case 'OPEN':
        return '#026FD4'; // Blue
      case 'IN PROGRESS':
        return '#FB9D05'; // Orange
      case 'RESOLVED':
        return '#0CA766';
      default:
        return '#000000'; // Black
    }
  }

  cleanText(text: string): string {
    return text.replace(/\s+/g, ' ');
  }

  onSubmit() {

    const strippedText = this.accpetTextremarks
      ?.replace(/<[^>]*>/g, '')   // remove all HTML tags
      ?.replace(/&nbsp;/g, '')    // remove HTML spaces
      ?.trim();                   // remove extra white space
    const finaltext = this.cleanText(strippedText);
    if (!finaltext) {
      this.toast.showError('Please Enter your Remarks');
      return;
    }


    if (!finaltext) {
      this.toast.showError('Please Enter your Remarks');
      return;
    }
    const formData = new FormData();
    formData.append("trackId", this.trackId);
    formData.append("grievanceId", this.grievanceId);
    formData.append("trackStatus", 'RESOLVED');
    formData.append("assignTo", this.assignTo || '');
    formData.append("description", finaltext);
    formData.append("empBuildingId", '0');
    formData.append("uploadDocumentStatus", this.documentStatus ? 'true' : 'false');
    formData.append("trackType", 'ACCEPT');
    formData.append("admNo", this.admNO);

    // if (this.selectedFile) {
    //   formData.append("file", this.selectedFile || null);
    // }
    if (this.selectedFile) {
      formData.append("file", this.selectedFile);
    }

    this.spinner.show();
    this.Service.postGrievance(formData).subscribe({
      next: (res: any) => {
        if (!res) {
          this.spinner.hide();
          return;
        }
        this.grievanceSaveDetails = res;

        // console.log('grievanceSaveDetails', this.grievanceSaveDetails)
        this.spinner.hide();
        this.toast.showSuccess('Grievance Resolved Successfully');
        this.disableAccept = true;
        this.disableAssign = true;
        this.disableEscalate = true;
        this.disableNote = true;
        this.showAccepted = false;
        this.onAssignShowMain = false;
        this.onEscalate = false;
        this.onNoted = false;
        this.grievanceStatus();
      },
      error: (err: any) => {
        this.spinner.hide();
      },
    });



  }

  //ACCEPT START DRAG AND DROP FILE UPLOADED //

  onFileSelected(event: Event) {
    const input = event.target as HTMLInputElement;
    if (input.files && input.files.length > 0) {
      const file = input.files[0];
      if (this.isValidFile(file)) {
        this.selectedFile = file;
        this.fileError = '';
        this.documentStatus = true;
        // console.log('Selected file:', this.selectedFile);
      }
      else {
        this.selectedFile = null;
        this.documentStatus = false;
      }
    }
  }

  onDrop(event: DragEvent) {
    event.preventDefault();
    if (event.dataTransfer?.files.length) {
      const file = event.dataTransfer.files[0];
      if (this.isValidFile(file)) {
        this.selectedFile = file;
        this.fileError = '';
        // console.log('Dropped file:', this.selectedFile);
      }
    }
  }

  onDragOver(event: DragEvent) {
    event.preventDefault();
  }

  isValidFile(file: File): boolean {
    if (file.size > 1048576) { // Less than 1 MB
      this.fileError = 'File size should be less than 1 MB.';
      this.selectedFile = null;
      return false;
    }
    return true;
  }

  // END DRAG AND DROP FILE UPLOADED //

  // ACCEPT CANCEL BUTTON //
  cancel() {
    localStorage.removeItem('currentTab');
    this.accpetTextremarks = '';
    const formData = new FormData();
    formData.append("trackId", this.trackId);
    formData.append("grievanceId", this.grievanceId);
    formData.append("trackStatus", 'OPEN');
    formData.append("assignTo", this.assignTo || '');
    formData.append("description", this.accpetTextremarks);
    formData.append("empBuildingId", '0');
    formData.append("uploadDocumentStatus", this.documentStatus ? 'true' : 'false');
    formData.append("trackType", 'ACCEPT');
    formData.append("admNo", this.admNO);
    if (this.selectedFile) {
      formData.append("file", this.selectedFile);
    }

    this.spinner.show();
    this.Service.postGrievance(formData).subscribe({
      next: (res: any) => {
        if (!res) {
          this.spinner.hide();
          return;
        }
        this.grievanceSaveDetails = res;
        this.spinner.hide();
        // this.toast.showSuccess('Grievance Resolved Successfully');
        this.disableAccept = true;
        this.disableAssign = true;
        this.disableEscalate = true;
        this.disableNote = true;
        this.showAccepted = false;
        this.onAssignShowMain = false;
        this.onEscalate = false;
        this.onNoted = false;
        this.grievanceStatus();
      },
      error: (err: any) => {
        this.spinner.hide();
      },
    });


    this.Service.setView('grievance');

  }
  //END ACCEPT CANCEL BUTTON //

  // ASSIGN CANCEL BUTTON //
  assigncancel() {
    localStorage.removeItem('currentTab');
    this.assignTextremarks = ''
    this.showAccepted = false;
    this.onAssignShowMain = false;
    this.onEscalate = false;
    this.onNoted = false;
    this.disableAccept = false;
    this.disableAssign = false;
    this.disableEscalate = false;
    this.disableNote = false;
    this.getStatusColor();
    // this.router.navigate(['/grievanceDashboard']);
  }
  //END ASSIGN CANCEL BUTTON //

  //ESCALATE CANCEL BUTTON //
  escalatecancel() {
    localStorage.removeItem('currentTab');
    this.escalatedTextremarks = ''
    this.showAccepted = false;
    this.onAssignShowMain = false;
    this.onEscalate = false;
    this.onNoted = false;
    this.disableAccept = false;
    this.disableAssign = false;
    this.disableEscalate = false;
    this.disableNote = false;
    this.getStatusColor();
    // this.router.navigate(['/grievanceDashboard']);
  }
  //END ESCALATE CANCEL BUTTON //

  //NOTE CANCEL BUTTON //
  notecancel() {

    localStorage.removeItem('currentTab');
    this.noteTextremarks = ''
    this.showAccepted = false;
    this.onAssignShowMain = false;
    this.onEscalate = false;
    this.onNoted = false;
    this.disableAccept = false;
    this.disableAssign = false;
    this.disableEscalate = false;
    this.disableNote = false;
    this.getStatusColor();
    // this.router.navigate(['/grievanceDashboard']);
  }
  //END NOTE CANCEL BUTTON //

  // click assist//
  onAssign() {
    this.onAssignShowMain = true;
    this.onEscalate = false;
    this.onNoted = false;
    this.showAccepted = false;
    this.onacceptticket = false;
    this.disableAccept = true;
    this.disableAssign = true;
    this.disableEscalate = true;
    this.disableNote = true;
    this.getStatusColor();
    this.showBackgroundColor('Assign');
  }
  onAssignedTicket() {

    this.getStatusColor();
    if (!this.searchCriteria) {
      this.toast.showError('Please select Assign Employee');
      return
    }

    if (!this.assignTextremarks) {
      this.toast.showError('Please Enter your Remarks');
      return;
    }

    const formData = new FormData();
    formData.append("trackId", this.trackId);
    formData.append("grievanceId", this.grievanceId);
    formData.append("trackStatus", 'OPEN');
    formData.append("assignTo", this.assignTo || '');
    formData.append("description", this.assignTextremarks);
    formData.append("empBuildingId", '0');
    formData.append("uploadDocumentStatus", this.documentStatus ? 'true' : 'false');
    formData.append("trackType", 'ASSIGN');
    formData.append("admNo", this.admNO);

    if (this.selectedFile) {
      formData.append("file", this.selectedFile);
    }

    this.spinner.show();
    this.Service.postGrievance(formData).subscribe({
      next: (res: any) => {
        if (!res) {
          this.spinner.hide();
          return;
        }
        this.grievanceSaveDetails = res;
        console.log('grievanceSaveDetails', this.grievanceSaveDetails)
        this.spinner.hide();
        this.toast.showSuccess('Grievance Assigned Successfully');
        this.onAssignShowMain = false;
        this.showAccepted = false;
        this.onEscalate = false;
        this.onNoted = false;
        this.disableAccept = true;
        this.disableAssign = true;
        this.disableEscalate = true;
        this.disableNote = true;
        this.onAssignShowMain = false;
        this.grievanceStatus();
      },
      error: (err: any) => {
        this.spinner.hide();
      },
    });

  }

  // CLICK ESCALATE//
  onEscalated() {
    this.onEscalate = true;
    this.onAssignShowMain = false;
    this.showAccepted = false;
    this.onNoted = false;
    this.onacceptticket = false;
    this.disableAccept = true;
    this.disableAssign = true;
    this.disableEscalate = true;
    this.disableNote = true;
    this.showBackgroundColor('Escalate');
  }
  onEscalateTicket() {

    this.getStatusColor();
    if (!this.escalatedTextremarks) {
      this.toast.showError('Please Enter your Remarks');
      return
    }

    const formData = new FormData();
    formData.append("trackId", this.trackId);
    formData.append("grievanceId", this.grievanceId);
    formData.append("trackStatus", 'OPEN');
    formData.append("assignTo", this.assignTo || '');
    formData.append("description", this.escalatedTextremarks);
    formData.append("empBuildingId", '0');
    formData.append("uploadDocumentStatus", this.documentStatus ? 'true' : 'false');
    formData.append("trackType", 'ESCALATE');
    formData.append("admNo", this.admNO);

    if (this.selectedFile) {
      formData.append("file", this.selectedFile);
    }
    this.spinner.show();
    this.Service.postGrievance(formData).subscribe({
      next: (res: any) => {
        if (!res) {
          this.spinner.hide();
          return;
        }
        this.grievanceSaveDetails = res;
        console.log('grievanceSaveDetails', this.grievanceSaveDetails)
        this.spinner.hide();
        this.toast.showSuccess('Grievance Escalated Successfully');
        this.onAssignShowMain = false;
        this.showAccepted = false;
        this.onEscalate = false;
        this.onNoted = false;
        this.disableAccept = true;
        this.disableAssign = true;
        this.disableEscalate = true;
        this.disableNote = true;
        this.onAssignShowMain = false;
        this.grievanceStatus();
      },
      error: (err: any) => {
        this.spinner.hide();
      },
    });

  }

  // CLICK NOTE//

  onNote() {
    this.onNoted = true;
    this.disableAccept = true;
    this.disableAssign = true;
    this.disableEscalate = true;
    this.disableNote = true;
    this.showAccepted = false;
    this.onEscalate = false;
    this.onAssignShowMain = false;
    // this.onShowMainAccept = false;
    this.onacceptticket = false;
    this.getStatusColor();
    this.showBackgroundColor('Note');

  }

  onsubmitNote() {
    if (!this.noteTextremarks) {
      this.toast.showError('Please Enter your Remarks');
      return
    }

    this.getStatusColor();
    const formData = new FormData();
    formData.append("trackId", this.trackId);
    formData.append("grievanceId", this.grievanceId);
    formData.append("trackStatus", this.grievanceStatusDetails?.latest?.trackStatus || "OPEN");
    formData.append("assignTo", this.assignTo || '');
    formData.append("description", this.noteTextremarks);
    formData.append("empBuildingId", '0');
    formData.append("uploadDocumentStatus", this.documentStatus ? 'true' : 'false');
    formData.append("trackType", 'NOTE');
    formData.append("admNo", this.admNO);

    if (this.selectedFile) {
      formData.append("file", this.selectedFile);
    }

    this.spinner.show();
    this.Service.postGrievance(formData).subscribe({
      next: (res: any) => {
        if (!res) {
          this.spinner.hide();
          return;
        }
        this.grievanceSaveDetails = res;
        console.log('grievanceSaveDetails', this.grievanceSaveDetails)
        this.spinner.hide();
        this.toast.showSuccess('Grievance Noted Successfully');
        this.onAssignShowMain = false;
        this.showAccepted = false;
        this.onEscalate = false;
        this.onNoted = false;
        this.onAssignShowMain = false;
        this.grievanceStatus();
      },
      error: (err: any) => {
        this.spinner.hide();
      },
    });

  }
  selectItem(item: any) {
    console.log('item', item);
    this.assignTo = item.payrollId;
    this.searchCriteria = item.empName;
    this.searchDetails = [];
    this.filteredSearchDetails = [];
    this.showDropdown = false;
  }

  onKeyUp(event: any) {
    const inputValue = event.target.value;
    if (!inputValue) {
      this.filteredSearchDetails = [];
    }
    else if (inputValue.length > 5) {
      const selectedlist = inputValue;
      this.employeeSearch(selectedlist);
    }

  }

  onKeyDown(event: any) {
    if (event.key === 'Enter') {
      this.employeeSearch(this.searchCriteria);
    }
  }
  employeeSearch(selectedlist: any) {
    // this.spinner.show();
    this.Service.getEmployeeDetails(selectedlist, this.campusId).subscribe(
      {
        next: (res: any) => {
          this.searchDetails = res;
          this.filteredSearchDetails = res;
          this.showDropdown = this.searchDetails.length > 0;
          console.log('searchDetails', this.searchDetails);
          // this.spinner.hide();
        },
        error: (err: any) => {
          // this.spinner.hide();
        }
      }
    )
  }


  radialBar() {
    this.chart = new Chart({
      chart: {
        type: 'solidgauge',
        height: 24,
        width: 24,
        backgroundColor: 'transparent',
        margin: [0, 0, 0, 0],
      },
      title: undefined,
      tooltip: { enabled: false },
      credits: { enabled: false },
      pane: {
        startAngle: 0,
        endAngle: 360,
        size: '100%',
        background: [
          {
            outerRadius: '100%',
            innerRadius: '80%',
            backgroundColor: '#e6e6e6',
            borderWidth: 0,
          },
        ],
      },
      yAxis: {
        min: 0,
        max: 7,
        lineWidth: 0,
        tickPositions: [],
        labels: { enabled: false },
      },
      plotOptions: {
        solidgauge: {
          dataLabels: {
            enabled: true,
            useHTML: true,
            format: `
        <div style="
        position: absolute;
         top: 50%;
          left: 50%;
           transform: translate(-30%, -68%);
          font-size: 14px;
          line-height: 14px;
          width: 100%;
          text-align: center;
          color: black;
        ">
          {y}
        </div>
      `,
            borderWidth: 0,
            y: 0,
          },
          linecap: 'round',
        },
      },
      series: [
        {
          type: 'solidgauge',
          name: 'Days Left',
          data: [
            {
              color: '#FF3B30',
              radius: '100%',
              innerRadius: '80%',
              y: 7,
            },
          ],
        } as any,
      ],
    });
    // Wait until the chart is ready
    // setTimeout(() => {
    //   const highchartsChart = this.chart.ref;
    //   if (highchartsChart) {
    //     let interval = setInterval(() => {
    //       const current = highchartsChart.series[0].data[0].y as number;
    //       if (current > 0) {
    //         highchartsChart.series[0].data[0].update(current - 1);
    //       } else {
    //         clearInterval(interval);
    //       }
    //     }, 1000);
    //   }
    // }, 300);
  }



  ngOnDestroy(): void {
    this.editor.destroy();
  }

}

